var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSidebarBrowsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_845_16838)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8125 7.4292H3.4375C3.0578 7.4292 2.75 7.737 2.75 8.1167V17.7417C2.75 18.1214 3.0578 18.4292 3.4375 18.4292H15.8125C16.1922 18.4292 16.5 18.1214 16.5 17.7417V8.1167C16.5 7.737 16.1922 7.4292 15.8125 7.4292Z",
    stroke: "#EEEFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 7.4292V5.3667C5.5 5.18436 5.57243 5.00949 5.70136 4.88056C5.8303 4.75163 6.00516 4.6792 6.1875 4.6792H18.5625C18.7448 4.6792 18.9197 4.75163 19.0486 4.88056C19.1776 5.00949 19.25 5.18436 19.25 5.3667V14.9917C19.25 15.174 19.1776 15.3489 19.0486 15.4778C18.9197 15.6068 18.7448 15.6792 18.5625 15.6792H16.5",
    stroke: "#EEEFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.75 10.1792H16.5",
    stroke: "#EEEFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_845_16838"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0 0.554199)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSidebarBrowsers);
export default __webpack_public_path__ + "static/media/icon-sidebar-browsers.c1f7e40687c0349be7b20ba66321a4a1.svg";
export { ForwardRef as ReactComponent };